import { Controller } from "@hotwired/stimulus"

// The copy button on a markdown table (Chat::MarkdownRenderer) in a message that has no
// pipeline-result controller around it: Platform chat turns, in the panel and on the PharOS
// page. Same TSV copy and checkmark as pipeline-result's.
export default class extends Controller {
  copy(event) {
    const btn = event.target.closest(".laz-copy-btn")
    const tbl = btn?.closest(".laz-mdtbl-wrap")?.querySelector("table")
    if (!tbl) return
    const text = [...tbl.rows].map(r => [...r.cells].map(c => c.textContent.trim()).join("\t")).join("\n")
    navigator.clipboard.writeText(text).catch(() => {})
    const orig = btn.innerHTML
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px;color:#10b981"><path d="M20 6 9 17l-5-5"/></svg>'
    setTimeout(() => { btn.innerHTML = orig }, 1500)
  }
}
